module.exports = __webpack_public_path__ + "static/media/defaultBg.e33518a0.jpg";